import { DeploymentRequestListPageState } from ".";

export const DeploymentRequestListPageInitialState: DeploymentRequestListPageState =
  {
    dipByRgn: "",
    schedDateRange: {
      startDate: "",
      endDate: "",
    },
    incClosed: false,
    dplymntEnv: "",
    /**
     * Page List
     */
    searchResult: {
      deploymentRequestList: [],
    },
    fieldPath: {
      dipByRgn: "dipByRgn",
      schedDateStart: "schedDateStart",
      schedDateEnd: "schedDateEnd",
      incClosed: "dplymntStsList",
      dplymntEnv: "dplymntEnv",
    },
  };
